"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HTMLWidget = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _panel = _interopRequireDefault(require("@insided/deprecated-control/panel"));

var _Modal = require("@insided/shared/uikit/Modal");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _CodeEditor = _interopRequireDefault(require("@insided/shared/uikit/CodeEditor"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HTMLWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HTMLWidget, _Component);

  var _super = _createSuper(HTMLWidget);

  function HTMLWidget(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HTMLWidget);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.content || '',
      showModal: false,
      isError: false,
      title: _this.props.title
    });
    _this.handleModalToggle = _this.handleModalToggle.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseNotification = _this.handleCloseNotification.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDeleteButton = _this.handleDeleteButton.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(HTMLWidget, [{
    key: "handleModalToggle",
    value: function handleModalToggle() {
      this.setState(function (state) {
        return {
          showModal: !state.showModal
        };
      });
    }
  }, {
    key: "handleCloseNotification",
    value: function handleCloseNotification() {
      this.setState({
        isError: false
      });
    }
  }, {
    key: "handleDeleteButton",
    value: function handleDeleteButton() {
      this.props.deleteButtonAction();
      this.handleModalToggle();
    }
  }, {
    key: "notifyChanges",
    value: function notifyChanges() {
      this.props.onChange({
        html: this.state.content,
        title: this.state.title
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          content = _this$state.content,
          title = _this$state.title,
          showModal = _this$state.showModal,
          isError = _this$state.isError;
      var options = {
        lineNumbers: true,
        mode: 'text/html',
        selectionPointer: true,
        autoRefresh: false,
        autoResize: false
      };
      return (0, _preact.h)("div", null, isError && (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        message: "",
        renderHTML: true,
        onClose: function onClose() {
          return _this2.handleCloseNotification();
        }
      }), (0, _preact.h)("form", {
        className: "html-widget__form"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Title",
        type: "text",
        onChange: function onChange(event) {
          _this2.setState({
            title: event.target.value
          }, function () {
            return _this2.notifyChanges();
          });
        },
        value: title
      }), (0, _preact.h)("div", {
        className: "widget-configuration_info-box"
      }, (0, _preact.h)("p", null, "Please ensure that any custom content you add meets accessibility requirements.")), (0, _preact.h)(_CodeEditor.default, {
        defaultValue: content,
        onChange: function onChange(content) {
          _this2.setState({
            content: content
          }, function () {
            return _this2.notifyChanges();
          });
        },
        options: options
      })), !this.props.hideDeleteButton && (0, _preact.h)(_Button.default, {
        variant: "warning",
        title: "Delete",
        onClick: function onClick() {
          return _this2.handleModalToggle();
        }
      }), (0, _preact.h)(_Modal.Modal, {
        isOpen: showModal,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Delete HTML Widget?",
        onClose: function onClose() {
          return _this2.handleModalToggle();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, "If you delete this widget, it's gone for good."), (0, _preact.h)(_Button.default, {
        variant: "danger",
        title: "Delete",
        onClick: function onClick() {
          return _this2.handleDeleteButton();
        }
      }), (0, _preact.h)(_Button.default, {
        variant: "secondary",
        title: "Cancel",
        onClick: function onClick() {
          return _this2.handleModalToggle();
        }
      }))));
    }
  }]);
  return HTMLWidget;
}(_preact.Component);

exports.HTMLWidget = HTMLWidget;

var HTMLWidgetPanel = function HTMLWidgetPanel(props) {
  return (0, _preact.h)(_panel.default, {
    collapsible: true,
    customClass: "homepage-widget homepage-widget--html",
    title: (0, _preact.h)("div", {
      className: "panel-title-with-switch"
    }, (0, _preact.h)("div", {
      className: "homepage-reorderable-panel-title"
    }, props.dragHandle, (0, _preact.h)("span", null, "HTML widget")), props.switcher)
  }, (0, _preact.h)(HTMLWidget, props));
};

var _default = HTMLWidgetPanel;
exports.default = _default;